import React from "react";
import Env from "../../../util/env";

export default function AuthLayoutVersion() {
    const commitHash = import.meta.env.VITE_COMMIT_HASH;
    const currentVersion = Env.getNpmPackageVersion();

    return <div className="absolute bottom-3 right-3 text-right px-2">
        {currentVersion && (
            <span className="text-tm-gray-500">{currentVersion}</span>
        )}

        {commitHash && (
            <span className="text-tm-gray-400"> ({commitHash})</span>
        )}
    </div>
}